const letters = document.getElementById('letters');
const wordInput = document.getElementById('word-input');
const submitButton = document.getElementById('submit-word');
const newLettersButton = document.getElementById('new-letters');
const scoreDisplay = document.getElementById('score');
const wordList = document.getElementById('word-list');
let randomLetters = '';
let score = 0;
let usedWords = new Set();

function generateRandomLetters() {
    const requiredLetters = 'AERIOTNSLC';
    const consonants = 'BDFGHJKMPQUVWXYZ';
    const vowels = 'AEIOU';
    
    const letterCount = Math.floor(Math.random() * 4) + 6;
    const maxVowels = Math.max(1, Math.floor(letterCount / 3)); // Restrict vowels to not more than 1/3 of total length, but at least 1
    
    randomLetters = '';
    let vowelCount = 0;

    // Add required letters
    for (let i = 0; i < 2; i++) {
        const randomIndex = Math.floor(Math.random() * requiredLetters.length);
        const letter = requiredLetters[randomIndex];
        randomLetters += letter;
        if (vowels.includes(letter)) {
            vowelCount++;
        }
    }
    
    // Fill the remaining letters with the vowel constraint
    for (let i = randomLetters.length; i < letterCount; i++) {
        if (vowelCount < maxVowels && Math.random() < 0.4) { // 40% chance to pick a vowel
            const randomVowel = vowels[Math.floor(Math.random() * vowels.length)];
            randomLetters += randomVowel;
            vowelCount++;
        } else {
            const randomConsonant = consonants[Math.floor(Math.random() * consonants.length)];
            randomLetters += randomConsonant;
        }
    }
    
    randomLetters = randomLetters.split('').sort(() => Math.random() - 0.5).join('');
    
    letters.textContent = randomLetters;
}


function resetGame() {
    generateRandomLetters();
    score = 0;
    usedWords.clear();
    scoreDisplay.textContent = 'Score: 0';
    wordList.innerHTML = '';
    wordInput.value = '';
}

function isValidWord(word) {
    const letterCounts = {};
    for (const letter of randomLetters) {
        letterCounts[letter] = (letterCounts[letter] || 0) + 1;
    }
    
    for (const letter of word.toUpperCase()) {
        if (!letterCounts[letter]) return false;
    }
    
    return true;
}

async function isEnglishWord(word) {
    const url = `https://api.datamuse.com/words?sp=${word}&md=d`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        
        // Check if the word exists and has a definition
        if (data.length > 0 && data[0].word.toLowerCase() === word.toLowerCase()) {
            return data[0].defs !== undefined;
        }
        return false;
    } catch (error) {
        console.error('Error checking word:', error);
        return false;
    }
}

async function submitWord() {
    const word = wordInput.value.trim().toLowerCase();
    
    if (word && isValidWord(word) && !usedWords.has(word)) {
        const isValid = await isEnglishWord(word);
        
        if (isValid) {
            score += word.length;
            scoreDisplay.textContent = `Score: ${score}`;
            usedWords.add(word);
            const wordElement = document.createElement('div');
            wordElement.textContent = word;
            wordList.appendChild(wordElement);
        } else {
            alert(`${word} is not a valid English word.`);
        }
    }
    
    wordInput.value = '';
}

submitButton.addEventListener('click', submitWord);
newLettersButton.addEventListener('click', resetGame);
wordInput.addEventListener('keyup', (event) => {
    if (event.key === 'Enter') {
        submitWord();
    }
});

resetGame();
